var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "reminder-item" }, [
    _c(
      "div",
      [
        _c("feather-icon", {
          staticClass: "mr-50 h-6 w-6",
          attrs: { icon: "ClockIcon" }
        })
      ],
      1
    ),
    _c("div", { staticClass: "mr-50", attrs: { id: "item" } }, [
      !_vm.activeForm
        ? _c(
            "div",
            {
              staticClass: "hover:text-primary",
              on: {
                click: function($event) {
                  return _vm.openReminderEdit(_vm.reminder)
                }
              }
            },
            [_c("span", [_vm._v(" " + _vm._s(_vm.durationDisplay) + " ")])]
          )
        : _c(
            "div",
            { staticClass: "w-full" },
            [
              _c(
                "b-form",
                {
                  staticClass: "gap-1 w-full flex-wrap",
                  attrs: { inline: "" }
                },
                [
                  _c("b-form-input", {
                    staticClass: "inline",
                    attrs: { id: _vm.idx + "-reminder-time" },
                    model: {
                      value: _vm.reminderForm.time,
                      callback: function($$v) {
                        _vm.$set(_vm.reminderForm, "time", $$v)
                      },
                      expression: "reminderForm.time"
                    }
                  }),
                  _c("b-form-select", {
                    staticClass: "inline",
                    attrs: {
                      id: _vm.idx + "-reminder-time-unit",
                      options: _vm.timeUnits
                    },
                    model: {
                      value: _vm.reminderForm.unit,
                      callback: function($$v) {
                        _vm.$set(_vm.reminderForm, "unit", $$v)
                      },
                      expression: "reminderForm.unit"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
    ]),
    !_vm.disabled
      ? _c(
          "div",
          [
            !_vm.activeForm
              ? _c("feather-icon", {
                  staticClass:
                    "h-5 w-5 stroke-current text-danger cursor-pointer float-right",
                  attrs: { icon: "Trash2Icon", size: "21" },
                  on: {
                    click: function($event) {
                      return _vm.removeReminder(_vm.reminder)
                    }
                  }
                })
              : _c(
                  "div",
                  { staticClass: "float-right flex gap-1 flex-row" },
                  [
                    _c("feather-icon", {
                      staticClass:
                        "h-5 w-5 stroke-current text-success cursor-pointer",
                      attrs: { icon: "PlusIcon", size: "21" },
                      on: {
                        click: function($event) {
                          return _vm.saveEdit()
                        }
                      }
                    }),
                    _vm.idx !== null && _vm.idx >= 0
                      ? _c("feather-icon", {
                          staticClass:
                            "h-5 w-5 stroke-current text-danger cursor-pointer",
                          attrs: { icon: "XCircleIcon", size: "21" },
                          on: {
                            click: function($event) {
                              return _vm.cancelEdit()
                            }
                          }
                        })
                      : _vm._e()
                  ],
                  1
                )
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }